var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.isPc
    ? _c("div", { staticClass: "home" }, [_vm._m(0)])
    : _c("div", { staticClass: "home" }, [_vm._m(1)])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "carousel-item" }, [
      _c("div", { staticClass: "banner" }),
      _vm._v(" "),
      _c("div", { staticClass: "company-introduct" }, [
        _c("div", { staticClass: "div-item" }, [
          _c("h1", [_vm._v("企业简介")]),
          _vm._v(" "),
          _c("span", { staticClass: "detail" }, [_vm._v("COMPANY PROFILE")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "border div-item" }, [
          _c("p", [
            _vm._v(
              " 苏州亿数腾云科技有限公司团队成立于2008年，由一批专注于软件和硬件系统集成的行业精英组成。十多年的开发经验，奠定了强大的技术实力。于2018年正式成立科技公司，公司延续了强大的开发能力，并且将优势定位于企业管理类，工业流程类，大数据分析，物联网应用等解决方案。崭新的解决方案已经给数十家客户带来福音。"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "border div-item" }, [
          _c("p", [
            _vm._v(
              "亿数人秉承不断进取，勇于创新理念，以客户需求为出发点，实实在在的服务好客户。已经在各行各业获得了客户一致好评。\n\t\t\t\t\t\t\t\t"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "company-profile" }, [
        _c("div", { staticClass: "div-item" }, [
          _c("h1", [_vm._v("企业文化")]),
          _vm._v(" "),
          _c("span", { staticClass: "detail" }, [_vm._v("COMPANY PROFILE")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile" }, [
          _c("div", { staticClass: "width-30 hezuo" }, [
            _c("img", {
              staticClass: "hezuo",
              attrs: { src: require("../../../assets/home/hezuo.jpg") }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "width-70" }, [
            _c("div", { staticClass: "border div-item" }, [
              _c("p", [
                _vm._v(
                  " 成功靠朋友，成长靠对手，成就靠团队。创意是金钱，策划显业绩，思考才致富。知道是知识，做到才智慧，多做少多说。积极激励我，多劳多收获，汗水育成果。梦想聚团队，团队铸梦想，激情快乐人。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "border div-item" }, [
              _c("p", [
                _vm._v(
                  "快乐让公司环境变得令人愉快点吧。当人们喜欢他们所做的工作，并且乐于与那些一起工作的人共事，他们就会高效率地工作。\n\t\t\t\t\t\t\t\t\t\t"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "border div-item" }, [
              _c("p", [
                _vm._v(
                  "目标明确，坚定不移，天道酬勤，永续经营。\n\t\t\t\t\t\t\t\t\t\t"
                )
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "carousel-item" }, [
      _c("div", { staticClass: "banner" }),
      _vm._v(" "),
      _c("div", { staticClass: "company-introduct" }, [
        _c("div", { staticClass: "div-item" }, [
          _c("h1", [_vm._v("企业简介")]),
          _vm._v(" "),
          _c("span", { staticClass: "detail" }, [_vm._v("COMPANY PROFILE")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "border div-item" }, [
          _c("p", [
            _vm._v(
              " 苏州亿数腾云科技有限公司团队成立于2008年，由一批专注于软件和硬件系统集成的行业精英组成。十多年的开发经验，奠定了强大的技术实力。于2018年正式成立科技公司，公司延续了强大的开发能力，并且将优势定位于企业管理类，工业流程类，大数据分析，物联网应用等解决方案。崭新的解决方案已经给数十家客户带来福音。"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "border div-item" }, [
          _c("p", [
            _vm._v(
              "亿数人秉承不断进取，勇于创新理念，以客户需求为出发点，实实在在的服务好客户。已经在各行各业获得了客户一致好评。\n\t\t\t\t\t\t\t\t"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "company-profile" }, [
        _c("div", { staticClass: "div-item" }, [
          _c("h1", [_vm._v("企业文化")]),
          _vm._v(" "),
          _c("span", { staticClass: "detail" }, [_vm._v("COMPANY PROFILE")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile" }, [
          _c("div", { staticClass: "border div-item" }, [
            _c("p", [
              _vm._v(
                " 成功靠朋友，成长靠对手，成就靠团队。创意是金钱，策划显业绩，思考才致富。知道是知识，做到才智慧，多做少多说。积极激励我，多劳多收获，汗水育成果。梦想聚团队，团队铸梦想，激情快乐人。"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "border div-item" }, [
            _c("p", [
              _vm._v(
                "快乐让公司环境变得令人愉快点吧。当人们喜欢他们所做的工作，并且乐于与那些一起工作的人共事，他们就会高效率地工作。\n\t\t\t\t\t\t\t\t\t\t"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "border div-item" }, [
            _c("p", [
              _vm._v(
                "目标明确，坚定不移，天道酬勤，永续经营。\n\t\t\t\t\t\t\t\t\t\t"
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-535d5e56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-535d5e56","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/custom/home/index.vue
// module id = nSIH
// module chunks = 3